export default "__VITE_ASSET__D1q0PUMN__"